import { ButtonGroup } from '@/components/ui/button-group';
import { cn } from '@/lib/utils';

interface ToggleButtonsOption<T extends string> {
  value: T;
  label: string;
}

interface ToggleButtonsProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: readonly ToggleButtonsOption<T>[];
  disabled?: boolean;
  className?: string;
}

/** Grupo de botões estilo segmented control, mesma linguagem visual do `FormSwitch`. */
export function ToggleButtons<T extends string>({
  value,
  onChange,
  options,
  disabled,
  className,
}: ToggleButtonsProps<T>) {
  return (
    <ButtonGroup className={cn('w-full', className)}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(option.value)}
          className={cn(
            'h-9 flex-1 border px-3 text-[13px] font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50',
            value === option.value
              ? 'border-olive-line/40 bg-primary-soft text-olive-ink'
              : 'border-border-strong bg-transparent text-muted-foreground hover:bg-muted',
          )}
        >
          {option.label}
        </button>
      ))}
    </ButtonGroup>
  );
}
